import React, { useState } from 'react';
import { Box, Text, Input, Button, Flex, Tabs, TabList, Tab, TabPanels, TabPanel, InputGroup, InputRightElement, IconButton, Link } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { Eye, EyeOff, MinusCircle } from 'lucide-react';
export function AccountPage() {
  const [tabIndex, setTabIndex] = useState(0);
  const [firstName, setFirstName] = useState('Keith');
  const [lastName, setLastName] = useState('Price');
  const [organization, setOrganization] = useState('zMagic Solutions');
  const email = 'kprice@zmagic.com';
  // Security tab state
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const handleCancel = () => {
    setFirstName('Keith');
    setLastName('Price');
    setOrganization('zMagic Solutions');
  };
  const handleSecurityCancel = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };
  const handleSave = () => {
    console.log('Saving:', {
      firstName,
      lastName,
      organization
    });
  };
  const requirements = ['Begin with a lowercase letter', 'Contain 10-64 characters', 'Contain upper & lower case letters', 'Contain at least 1 number', 'Contain at least 1 symbol (! & # $ % @ ^ *)', 'Not end with a number or symbol', 'Passwords match'];
  return <Box w="100vw" h="100vh" bg="white" overflow="auto" data-id="element-126">
      <Header data-id="element-127" />

      <Box pt="64px" px={6} py={6} data-id="element-128">
        <Box className="ml-[37px] mr-[37px] mt-[60px] mb-[60px]" data-id="element-129">
          {/* Tabs */}
          <Tabs index={tabIndex} onChange={setTabIndex} variant="unstyled" mb={4} data-id="element-130">
            <TabList gap={2} mb={4} data-id="element-131">
              <Tab px={4} py={1} borderRadius="md" fontWeight="semibold" fontSize="md" bg={tabIndex === 0 ? '#0d6dfc' : 'transparent'} color={tabIndex === 0 ? 'white' : '#0d6dfc'} _selected={{}} _hover={{
              opacity: 0.85
            }} data-id="element-132">
                General
              </Tab>
              <Tab px={4} py={1} borderRadius="md" fontWeight="semibold" fontSize="md" bg={tabIndex === 1 ? '#0d6dfc' : 'transparent'} color={tabIndex === 1 ? 'white' : '#0d6dfc'} _selected={{}} _hover={{
              opacity: 0.85
            }} data-id="element-133">
                Security
              </Tab>
            </TabList>

            <TabPanels data-id="element-134">
              {/* General Tab */}
              <TabPanel p={0} data-id="element-135">
                <Box border="2px solid #006666" borderRadius="md" bg="white" maxW="520px" p={6} data-id="element-136">
                  <Text fontSize="xl" fontWeight="bold" color="black" mb={4} data-id="element-137">
                    Profile Details
                  </Text>

                  {/* First Name — yellow bg, purple border */}
                  <Box mb={3} data-id="element-138">
                    <Input value={firstName} onChange={e => setFirstName(e.target.value)} bg="#FFFF99" border="1px solid" borderColor="purple.400" focusBorderColor="purple.600" _hover={{
                    borderColor: 'purple.500'
                  }} borderRadius="sm" fontSize="md" color="black" data-id="element-139" />
                  </Box>

                  {/* Last Name */}
                  <Box mb={3} borderBottom="1px solid #ccc" pb={2} data-id="element-140">
                    <Input variant="unstyled" value={lastName} onChange={e => setLastName(e.target.value)} fontSize="md" color="black" pl={1} data-id="element-141" />
                  </Box>

                  {/* Organization */}
                  <Box mb={3} borderBottom="1px solid #ccc" pb={2} data-id="element-142">
                    <Input variant="unstyled" value={organization} onChange={e => setOrganization(e.target.value)} fontSize="md" color="black" pl={1} data-id="element-143" />
                  </Box>

                  {/* Email — read-only */}
                  <Box mb={4} borderBottom="1px solid #ccc" pb={2} data-id="element-144">
                    <Input variant="unstyled" value={email} isReadOnly fontSize="md" color="gray.400" pl={1} cursor="default" data-id="element-145" />
                  </Box>

                  <Text fontSize="sm" color="#e53e3e" fontStyle="italic" mb={5} data-id="element-146">
                    (All fields are required.)
                  </Text>

                  <Flex gap={3} justify="center" data-id="element-147">
                    <Button bg="#e53e3e" color="white" _hover={{
                    bg: '#c53030'
                  }} _active={{
                    bg: '#9b2c2c'
                  }} borderRadius="md" px={6} fontSize="md" fontWeight="semibold" onClick={handleCancel} data-id="element-148">
                      Cancel
                    </Button>
                    <Button bg="#9BAEE8" color="white" _hover={{
                    bg: '#8A9FE0'
                  }} _active={{
                    bg: '#7A8FD0'
                  }} borderRadius="md" px={6} fontSize="md" fontWeight="semibold" onClick={handleSave} data-id="element-149">
                      Save Changes
                    </Button>
                  </Flex>
                </Box>
              </TabPanel>

              {/* Security Tab */}
              <TabPanel p={0} data-id="element-150">
                <Box border="2px solid #006666" borderRadius="md" bg="white" maxW="720px" p={6} data-id="element-151">
                  <Text fontSize="xl" fontWeight="bold" color="black" mb={5} data-id="element-152">
                    Change Password
                  </Text>

                  {/* Password fields row */}
                  <Flex gap={6} mb={5} align="flex-start" data-id="element-153">
                    {/* Current Password */}
                    <Box flex={1} data-id="element-154">
                      <Text fontSize="sm" color="gray.500" mb={1} data-id="element-155">
                        Current Password
                      </Text>
                      <Box borderBottom="1px solid #ccc" pb={1} data-id="element-156">
                        <InputGroup data-id="element-157">
                          <Input variant="unstyled" placeholder="Password" type={showCurrent ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} fontSize="md" color="gray.500" _placeholder={{
                          color: 'gray.400'
                        }} pl={1} data-id="element-158" />

                          <InputRightElement data-id="element-159">
                            <IconButton aria-label="Toggle current password" icon={showCurrent ? <EyeOff size={16} data-id="element-161" /> : <Eye size={16} data-id="element-162" />} variant="ghost" size="xs" color="gray.400" onClick={() => setShowCurrent(!showCurrent)} _hover={{
                            bg: 'transparent'
                          }} data-id="element-160" />
                          </InputRightElement>
                        </InputGroup>
                      </Box>
                    </Box>

                    {/* New Password + Confirm Password */}
                    <Box flex={1} data-id="element-163">
                      <Text fontSize="sm" color="gray.500" mb={1} data-id="element-164">
                        New Password
                      </Text>
                      <Box borderBottom="1px solid #ccc" pb={1} mb={4} data-id="element-165">
                        <InputGroup data-id="element-166">
                          <Input variant="unstyled" placeholder="Password" type={showNew ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} fontSize="md" color="gray.500" _placeholder={{
                          color: 'gray.400'
                        }} pl={1} data-id="element-167" />

                          <InputRightElement data-id="element-168">
                            <IconButton aria-label="Toggle new password" icon={showNew ? <EyeOff size={16} data-id="element-170" /> : <Eye size={16} data-id="element-171" />} variant="ghost" size="xs" color="gray.400" onClick={() => setShowNew(!showNew)} _hover={{
                            bg: 'transparent'
                          }} data-id="element-169" />
                          </InputRightElement>
                        </InputGroup>
                      </Box>

                      <Box borderBottom="1px solid #ccc" pb={1} data-id="element-172">
                        <InputGroup data-id="element-173">
                          <Input variant="unstyled" placeholder="Confirm Password" type={showConfirm ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} fontSize="md" color="gray.500" _placeholder={{
                          color: 'gray.400'
                        }} pl={1} data-id="element-174" />

                          <InputRightElement data-id="element-175">
                            <IconButton aria-label="Toggle confirm password" icon={showConfirm ? <EyeOff size={16} data-id="element-177" /> : <Eye size={16} data-id="element-178" />} variant="ghost" size="xs" color="gray.400" onClick={() => setShowConfirm(!showConfirm)} _hover={{
                            bg: 'transparent'
                          }} data-id="element-176" />
                          </InputRightElement>
                        </InputGroup>
                      </Box>
                    </Box>
                  </Flex>

                  {/* Bottom section: info box + requirements */}
                  <Flex gap={6} mb={6} align="flex-start" data-id="element-179">
                    {/* Important info box */}
                    <Box flex={1} border="2px solid #006666" borderRadius="md" bg="#f0fff4" p={4} data-id="element-180">
                      <Text fontSize="sm" color="black" lineHeight="1.6" data-id="element-181">
                        <Text as="span" fontWeight="bold" data-id="element-182">
                          IMPORTANT:
                        </Text>{' '}
                        80% of all security breaches are due to bad passwords.
                        The password requirements included here should be
                        considered the bare minimum. You should create a
                        password that is much more secure than these
                        requirements. Ultimately, YOU ARE RESPONSIBLE for the
                        security of your login account.
                      </Text>
                      <Text fontSize="sm" color="black" mt={3} lineHeight="1.6" data-id="element-183">
                        Here are two articles{' '}
                        <Link color="blue.500" fontWeight="bold" href="#" textDecoration="underline" data-id="element-184">
                          HERE
                        </Link>{' '}
                        and{' '}
                        <Link color="blue.500" fontWeight="bold" href="#" textDecoration="underline" data-id="element-185">
                          HERE
                        </Link>{' '}
                        with tips on creating a good password.
                      </Text>
                    </Box>

                    {/* Minimum requirements */}
                    <Box flex={1} data-id="element-186">
                      <Text fontSize="xs" fontWeight="bold" color="black" letterSpacing="0.08em" mb={2} data-id="element-187">
                        MINIMUM REQUIREMENTS
                      </Text>
                      {requirements.map(req => <Flex key={req} align="center" gap={2} mb={1} data-id="element-188">
                          <Box color="#e53e3e" flexShrink={0} data-id="element-189">
                            <MinusCircle size={14} data-id="element-190" />
                          </Box>
                          <Text fontSize="sm" color="#0d6dfc" data-id="element-191">
                            {req}
                          </Text>
                        </Flex>)}
                    </Box>
                  </Flex>

                  {/* Buttons */}
                  <Flex gap={3} justify="flex-end" data-id="element-192">
                    <Button bg="#e53e3e" color="white" _hover={{
                    bg: '#c53030'
                  }} _active={{
                    bg: '#9b2c2c'
                  }} borderRadius="md" px={6} fontSize="md" fontWeight="semibold" onClick={handleSecurityCancel} data-id="element-193">
                      Cancel
                    </Button>
                    <Button bg="#9BAEE8" color="white" _hover={{
                    bg: '#8A9FE0'
                  }} _active={{
                    bg: '#7A8FD0'
                  }} borderRadius="md" px={6} fontSize="md" fontWeight="semibold" data-id="element-194">
                      Save Changes
                    </Button>
                  </Flex>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
    </Box>;
}